// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"268":"Home","787":"ComingSoon"}[chunkId] || chunkId) + "." + {"8":"a154484c","268":"3754cd37","388":"1396d531","566":"b8e9ae81","745":"11446063","787":"190d3574"}[chunkId] + ".chunk.js";
};